import { Relation, StackNumberingEnumDto } from '../../.generated/admin-api';

import { ClearUserCacheAction } from '../types';

export interface UserState {
  username?: string;
  organizationRelations?: Relation[];
  departmentRelations?: Relation[];
  departments?: Department[];
  selectedDepartment?: Department;
}

export interface Department {
  id: string;
  name: string;
  organizationId: string;
  organizationName: string;
  stackNumbering?: StackNumberingEnumDto;
}

export const SET_USERNAME = 'SET_USERNAME';
export const GET_USER_INFO = 'GET_USER_INFO';
export const SET_SELECTED_DEPARTMENT = 'SET_SELECTED_DEPARTMENT';

interface SetUsername {
  type: typeof SET_USERNAME;
  username: string;
}

interface GetUserInfo {
  type: typeof GET_USER_INFO;
  organizationRelations?: Relation[];
  departmentRelations?: Relation[];
  departments: Department[];
}

interface SetSelectedDepartmentAction {
  type: typeof SET_SELECTED_DEPARTMENT;
  department?: Department;
}

export type UserActionTypes =
  | SetUsername
  | GetUserInfo
  | SetSelectedDepartmentAction
  | ClearUserCacheAction;
